import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import AliceCarousel from 'react-alice-carousel'
import 'react-alice-carousel/lib/alice-carousel.css'

import ContentTabs from './content-tabs';
import ContentItem from './content-item';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  background: #DEDEDE;
  padding: 30px 0 80px;

  .alice-carousel__dots-item {
    border: 1px solid #43582D;
    width: 10px;
    height: 10px;
    background: none;
    border-radius: 10px;
    &.__active {
      background: #43582D;
    }
  }
`;

const Title = styled.div`
  display: flex;
  strong {
    font: italic bold 50px 'Times new roman';
    color: #6A7C40;
    margin-right: 24px;
  }
`

const Items = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  @media (max-width: 789px) {
    overflow: hidden;
  }
`;

const Button = styled.div`
  margin-top: 60px;
  a {
    margin: 0 auto;
    cursor: pointer;
    max-width: 270px;
    width: 100%;
    background: #43582D;
    display: flex;
    border-radius: 3px;
    border: 0;
    color: #fff;
    height: 60px;
    text-decoration: none;
    align-items: center;
    font-size: 16px;
    padding: 0;
    &:hover {
      background: #648540;
      span {
        border-color: #567337;
      }
    }
    @media (max-width: 1080px) {
      margin: 0 auto;
    }
    span {
      height: 100%;
      flex-grow: 1;
      border-right: 1px solid #394B25;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    i {
      width: 50px;
      background: url(/images/arrow-right.png) center no-repeat;
      height: 100%;
    }
  }
`;

class Content extends Component {
  state = {
    active_category: 'Ver todos',
    link: '/conteudos',
    text: 'Ver todos os conteúdos',
    isMobile: false,
    language: '',
  }

  componentDidMount = () => {
    const { language } = this.context;
    window.addEventListener("resize", this.resize.bind(this));
    this.setState({language: language});
    this.resize()
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize);
  }

  componentDidUpdate() {
    const { language } = this.context;
    if (language === this.state.language)
      return false;
    let active_category = ''
    let text = ''
    switch (language) {
      case 'pt-br':
        active_category = 'Ver todos'
        text = 'Ver todos os conteúdos'
        break;
      case 'en-us':
        active_category = 'View all'
        text = 'View all content'
        break;
      case 'es-es':
        active_category = 'Ver todo'
        text = 'Ver todos los contenidos'
        break;
      default:
    }
    this.setState({text: text, language: language, active_category: active_category});
  }

  _toggleCategory = (e) => {
    const { language } = this.context;
    this.setState({"active_category": e.target.name})
    let text = ''
    switch (e.target.name) {
      case "Ver todos":
        switch (language) {
          case 'pt-br':
            text = 'Ver todos os conteúdos'
            break;
          case 'en-us':
            text = 'View all content'
            break;
          case 'es-es':
            text = 'Ver todos los contenidos'
            break;
          default:
        }
        this.setState({link: '/conteudos', text: text});
        break;
      case "Vídeos":
        switch (language) {
          case 'pt-br':
            text = 'Ver todos os vídeos'
            break;
          case 'en-us':
            text = 'View all videos'
            break;
          case 'es-es':
            text = 'Ver todos los videos'
            break;
          default:
        }
        this.setState({link: '/conteudos/videos', text: text});
        break;
      case "Blog":
        switch (language) {
          case 'pt-br':
            text = 'Ver todos os posts'
            break;
          case 'en-us':
            text = 'View all posts'
            break;
          case 'es-es':
            text = 'Ver todos los posts'
            break;
          default:
        }
        this.setState({link: '/conteudos/blog', text: text});
        break;
      case "Aprenda mais":
        switch (language) {
          case 'pt-br':
            text = 'Ver todos os posts'
            break;
          case 'en-us':
            text = 'View all posts'
            break;
          case 'es-es':
            text = 'Ver todos los posts'
            break;
          default:
        }
        this.setState({link: '/conteudos/na-midia', text: text});
        break;
      default:
    }
    return;
  }

  getItems = (items) => {
    return items.map((item, index) => <ContentItem {...item.data} uid={ item.uid } key={index} /> )
  }

  resize = () => {
    if (document.body.clientWidth > 540) {
      this.setState({ isMobile: false });
    } else {
      this.setState({ isMobile: true });
    }
  }

  render = () => {
    const { language } = this.context;
    const { categories, items, items_blog, items_noticias, items_videos } = this.props;
    let itemList = [];
    switch (this.state.active_category) {
      case "Ver todos":
      case "View all":
      case "Ver todo":
        itemList = items
        break;
      case "Videos":
      case "Vídeos":
        itemList = items_videos
        break;
      case "Blog":
        itemList = items_blog
        break;
      case "Aprenda mais":
      case "Learn more":
      case "Aprende más":
        itemList = items_noticias
        break;
      default:
    }
    let conteudos = ''
    switch (language) {
      case 'pt-br':
        conteudos = 'Conteúdos'
        break;
      case 'en-us':
        conteudos = 'Content'
        break;
      case 'es-es':
        conteudos = 'Contenidos'
        break;
      default:
    }
    return (
      <Container>
        <div className="wrapper">
          <Title>
            <strong>{ conteudos }</strong>
            <ContentTabs active={ this.state.active_category } toggleCategory={ this._toggleCategory } categories={ categories } />
          </Title>
          <Items>
            { this.state.isMobile && (
              <AliceCarousel 
                buttonsDisabled={true}
                items={this.getItems(itemList)}/>
            )}
            { !this.state.isMobile && this.getItems(itemList) }
          </Items>
          <Button>
            <Link to={ this.state.link }>
              <span>{ this.state.text }</span>
              <i></i>
            </Link>
          </Button>
        </div>
      </Container>
    );
  }
}

Content.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

Content.contextType = LanguageContext;

export default Content;
